import { ReactNode } from "react"

export const tooltipMessagesByNamespace = {
  common: {
    refresh: "새로고침",
    memoEdit: "메모 편집",
    zoomIn: "확대",
    zoomOut: "축소",
    minimize: "최소화",
    maximize: "최대화",
    restoreWindow: "창 복원",
    noPermission: "권한없음",
    detachWindow: "별도 창으로 보기",
    closeWindow: "창 닫기",
    openChat: "채팅",
    delete: "삭제",
    historyPaymentEdit: "과거 수납 수정",
    historyPaymentMove: "해당날짜 수납이동",
    submit: "제출",
    cancelSubmission: "제출 취소",
    print: "인쇄",
    exclude: "제외",
    cashReceiptToggle: "현금영수증 발행여부 수정",
    paymentCardAutoFill: "체크시, 이후 카드에 결제금액이 자동으로 들어갑니다.",
    paymentBalanceRefresh: "미수금 재계산",
    paymentFavoriteAlimtalkEdit: "자주사용하는 알림톡 편집",
    paymentFavoriteAlimtalkAdd: "자주사용하는 알림톡 추가",
    paymentFavoriteAlimtalkDelete: "자주사용하는 알림톡 삭제",
    paymentFavoriteAlimtalkCancel: "자주사용하는 알림톡 편집 취소",
    paymentFavoriteAlimtalkSave: "자주사용하는 알림톡 저장",
    paymentFavoriteAlimtalkSend: "선택한 알림톡 발송",
    paymentAutoAlimtalkEdit: "알림톡 자동발송 편집",
    paymentAutoAlimtalkCancel: "알림톡 자동발송 편집 취소",
    paymentAutoAlimtalkSave: "알림톡 자동발송 저장",
    paymentAutoAlimtalkAdd: "알림톡 자동발송 조건 추가",
    paymentAutoAlimtalkDelete: "알림톡 자동발송 조건 삭제",
    paymentAutoAlimtalkSettings: "알림톡 자동발송 설정",
    moveUp: "위로 이동",
    moveDown: "아래로 이동",
  },
  dashboard: {
    reservationListCopy: "해당날짜의 예약목록을 엑셀에 붙일수 있는 형태로 복사합니다. 엑셀에서 붙여넣기(ctrl+v)사용하세요.",
    openChart: "해당 차트 열기",
    patientRegistrationDate: "등록일",
    patientLastVisitDate: "최근내원일",
    patientNextReservationDate: "다음예약일",
    patientVisitCount: "내원횟수",
    packageUsageHistoryView: "사용이력 보기",
    packageSmsTemplateSettings: "패키지 문자 문구 설정",
    herbalSmsTemplateSettings: "한약 문자 문구 설정",
    treatmentRoomSettings: "치료실 설정",
    treatmentRoomOpenWindow: "새창으로 열기",
    treatmentRoomStatusBoard: "사용자 정의 치료실 현황판",
    treatmentRoomStatusConfigFolder: "현황판 UI 설정 폴더 열기",
    sigmaCallSettings: "시그마콜 타이머와 연결된 설정입니다.",
    waitingStatusBoardSettings: "대기환자 현황판 설정",
    treatmentRoomBedAlias: "베드 별칭 수정",
    treatmentRoomTheme: "치료실 테마",
    treatmentActionChange: "치료 액션 변경",
    insuranceTypeChange: "보험종류 변경",
    insuranceInfoView: "보험정보 보기",
    insuranceAddTa: "자보 보험 추가",
    insuranceTaCloseGuarantee: "지급보증서 종료일을 처리합니다.",
    insuranceAddAi: "산재 보험 추가",
    taValidityValidation: "특정기간에 대한 자동차보험 접수번호와 보증번호를 심평원자료와 비교합니다.",
    insuranceTaGuaranteeDeadlineGuide:
      "신규 자보 보증기한 계산방법\n사고일자 + 4주 -1일 (또는 사고일자 +27일)\n예) 사고일자 03.02(수) -> 보증기한 03.29(화)",
    insuranceStartDate: "보험시작일",
    insuranceOrgCode: "보장기관기호",
    insuranceCardNumber: "보험증번호",
    editPatientInfoGuide: "환자정보 수정방법 안내",
    patientClassificationSettings: "환자분류 설정",
    qualificationCheck: "자격조회",
    openFamilyLookup: "가족 조회",
    copyAddress: "주소복사",
    openHistory: "진료 이력 보기",
    openMonthlySummary: "지난 요약보기",
    historySettings: "진료이력 설정",
    openVital: "바이탈",
    copyPrescription: "처방복사하기",
    editEncounter: "해당 진료 수정",
    newMemo: "새 메모 작성",
    hidePatientMemo: "메모 숨기기",
    showPatientMemo: "메모 숨김 해제",
    changeDoctor: "진료의 변경",
    receipt: "수납하기",
    receiptPrescriptionIncomplete: "처방미완료\n수납하기",
    registerPatient: "접수하기",
    changeDepartment: "진료과목 수정",
    stepPrev: "이전 단계",
    stepNext: "다음 단계",
    treatmentComplete: "치료 종료",
    deletePatient: "환자 삭제",
    changeReceptionMemo: "접수메모 변경",
    cancelReception: "접수 취소하기",
    cancelReservation: "예약 취소하기",
    familyRepresentativeDeleteDisabled: "가족대표는 삭제할수 없습니다",
    reservationListToggle: "예약환자목록 보기/닫기",
    waitingListToggle: "대기환자목록 보기/닫기",
    treatmentListToggle: "치료환자목록 보기/닫기",
    completedListToggle: "완료환자목록 보기/닫기",
    elapsedTimeToggle: "경과시간보기",
    waitingOrderEdit: "순서변경",
    moreOptions: "정렬순서변경",
    patientAnalysis: "환자 분석",
    packagePurchase: "패키지 현황/구매",
  },
  encounter: {
    soapMacroImport: "엑셀형식으로 된 상용구 내용을 가져옵니다.",
    soapMacroExport: "엑셀형식으로 상용구 내용을 내보냅니다.",
    uninsuredAmountEdit: "클릭해서 비급여 항목 수정\n금액 클릭시 금액 변경",
    editEncounter: "진료 수정",
    kcdHistoryLoad: "최근 상병 불러오기",
    kcdSearch: "상병코드 검색",
    kcdBrowse: "상병코드 전체보기",
    kcdManage: "상병코드관리",
    kcdAdd: "상병 추가",
    chunaDisabledNoDiagnosis: "추나에 적합한 상병명이 없어 활성화되지 않았습니다.",
    disRegCodeInputSearch: "산정특례기호 입력 및 검색",
    disRegChangeDisabledAid: "급여 및 차상위 환자의 산정특례는 변경하실수 없습니다.",
    prescriptionGuide: "처방입력 버튼을 삭제하거나 추가할 수 있습니다.해당편집은 바로 적용되며 병원전체에 적용됩니다.",
    treatmentAreaRecommend: "치료부위가 기록되지 않은 처방에 상병에 따른 추천치료부위를 입력합니다.",
    treatmentRecordAppend: "진료기록부 하단에 추가로 처방과 그에 따른 치료부위를 입력합니다.",
    currentHerbalTreatmentRecordAppend: "현재 처방내역을 진료기록에 추가합니다. 자보첩약은 따로 추가하지 않아도 치료기록시 추가됩니다.",
    refreshList: "목록 새로고침",
    refresh: "새로고침",
    editExternalPharma: "원외탕전 수정",
    chunaHiraLookup: "추나 심평원 조회",
    insuranceDrugDurationEdit: "예상 소요일수를 수정합니다.",
    homeVisitPatientTypeEdit: "클릭해서 방문진료 대상자 유형 선택",
    medicalRecordTimeSingleOnly: "진료시간은 하루단위 진료기록부인경우에만 표시수정가능합니다",
    dailyStatusPrintFromMedicalRecord: "현재 창을 닫고 일자별 진료목록창을 불러온 뒤 목록 전체에 대한 진료기록부를 출력합니다.",
    majorTreatmentDifferentiation: "변증기술료는 초진 1회, 재진시 7일 이상 경과시 1회 가능하고 반드시 변증에 대한 내역이 기재되어야 합니다.",
    majorTreatmentJarak:
      "습부항 기준입니다. 현재 주상병에 대한 최초 습부 시술일 기준으로 계산합니다. 자보의 경우에는 상병이 변경되더라도 최초습부일기준이 변경되지 않습니다. 1주차 주 7회, 2~3주차 주 4회, 4주차 이후 주 2회까지 가능합니다.",
    majorTreatmentSamsul:
      "삼술은 침, 뜸, 부항을 같은 날 함께 시행한 횟수 기준입니다. 초진 후 3주 이내는 주 7회, 3주 이후에는 침은 매일 가능하나 뜸, 부항과 동시에 하는 삼술은 주 3회까지 가능합니다.",
    majorTreatmentAutoHerbal:
      "자보 첩약 기준입니다. 이전 자보첩약 처방일과 처방일수를 기준으로 계산하며, 최소 7일 이상 또는 직전 처방일수 이상 경과했을 때 다시 처방 가능으로 안내합니다. 최대21일까지 활성화하며 실제 제출 여부나 타원여부에 따른 가능여부는 가능여부를 조회해야합니다.",
    majorTreatmentAutoAcupuncture:
      "자보 약침 기준입니다. 사고 후 1주차 주 7회, 2~3주차 주 3회, 4~10주차 주 2회, 11주차 이후 주 1회까지 가능합니다. 같은 접수번호 기준으로 계산합니다.",
    majorTreatmentChuna: "건보 추나는 연간 20회 기준이며 칩 안내는 현재 남은 횟수 기준입니다. 자보 추나는 사고 기준으로 계산합니다.",
    majorTreatmentIR2: "IR2 가능 기준입니다. 자보 사고일 기준 17일 이내일 때 2부위 산정 가능으로 안내합니다.",
    majorTreatmentICT2: "ICT2 가능 기준입니다. 자보 사고일 기준 17일 이내일 때 2부위 산정 가능으로 안내합니다.",
  },
  top: {
    more: "더보기",
    menuSearch: "사용법 검색하기",
    resetToToday: "오늘 날짜로 리셋",
    otherDatePatients: "다른 진료일 환자 보기",
    prevDate: "이전 날짜",
    nextDate: "다음 날짜",
    sigmaChartApplication: "시그마차트 신청 페이지 열기",
    menuNewPatient: "",
    menuPatientManagement: "",
    menuTaPatient: "",
    menuUninsuredHerbal: "",
    menuSmsSend: "",
    menuReservation: "",
    menuSettlement: "",
    menuClaim: "",
    menuPurchase: "구매",
    menuControl: "",
    logout: "로그아웃",
    goHome: "처음으로 가기",
    detachedManual: "매뉴얼",
    detachedMessage: "메시지",
    detachedUninsured: "비급여/한약",
    detachedClaim: "청구",
    detachedPurchase: "구매",
    detachedCrm: "",
    detachedInquiry: "문의하기",
    detachedDigitalSignature: "전자서명",
    detachedWaitingStatus: "대기환자 현황",
    detachedTreatmentRoom: "치료실 현황",
    detachedImagePreview: "환자 이미지 미리보기",
    detachedPenChart: "펜차트 편집",
    detachedReservation: "예약",
    detachedPatientAnalysis: "환자 분석",
    detachedDoctalkSettings: "닥톡 환경설정",
  },
  chat: {
    captureScreen: "화면 캡쳐",
    selectFile: "파일 선택",
    download: "다운로드",
    openFolder: "폴더 열기",
    settings: "채팅 설정",
    searchHistory: "과거 대화 검색",
    searchHistoryDisabled: "과거내역 공개가 꺼져 있습니다.",
    searchOlder: "이전 검색 결과",
    searchNewer: "다음 검색 결과",
    closeSearch: "검색 닫기",
  },
  sms: {
    sendHistoryView: "문자 발송내역 보기",
    templateOrderCancel: "문자 템플릿 순서 변경 취소",
    imageRemove: "첨부 이미지 삭제",
    kakaoAlimtalkTemplateSync: "알리고 템플릿 동기화",
  },
  hira: {
    industrialClaimRequiresPrecheck: "사전점검이 완료된 내역만 청구가 가능합니다",
    syncHira: "심평원 동기화",
    chunaDetailLookup: "타원포함 제출조회",
    patientGuidePrint: "환자용 처방전 출력",
    autoInsuranceFallbackMatch: "상세조회된 보증내역이 없어 최종 보증번호로 비교한 결과",
    reviewChartUnavailable: "다른차트에서 생성된 내용이라 해당차트로 자동으로 이동할수 없습니다",
    taFullPatientBurdenExcluded: "자보 무보증은 심평원 제출 대상이 아닙니다.",
    missingTaHerbalGuide: "해당일자로 이동하여 한약처방을 추가해주세요",
    checklistPopupBlocked: "팝업이 안뜨는 경우",
    nhisChupyakDailyChupFixed: "2첩으로 고정.",
    nhisChupyakDeepFormulaFee: "심층변증방제료를 처방또는 제거합니다.",
    nhisChupyakSelfPay100: "자부담 100퍼센트로 적용합니다. 첩약건보의 총일수 가산에는 포함되지 않습니다.",
    nhisChupyakNoSelectableDiagnosis: "현재 진료상병목록에 선택가능한 인정상병이 없습니다. 클릭하면 상병명 입력이 가능합니다.",
  },
  control: {
    recalcDaily: "이 날짜의 통계 재계산",
    recalcWeekly: "이 주간 통계 재계산",
    recalcMonthly: "이 월간 통계 재계산",
    recalcYearly: "이 연간 통계 재계산",
    memberPasswordHangul: "비밀번호에 한글은 사용할 수 없습니다. 영어, 숫자, 특수문자로만 입력해 주세요.",
    memberPasswordRule: "영어대문자, 소문자, 숫자, 특수문자중에서 2종류이상의 10자리 이상 또는 3종류 이상의 8자리 이상의 비밀번호를 입력하세요.",
    memberPasswordConfirmMismatch: "비밀번호와 비밀번호확인이 일치하지 않습니다.",
    hiraHerbalRegisterSelected: "좌측 전체 한약재 제품목록에서 선택된 약재를 원내한약재로 등록합니다.",
    hiraHerbalBulkRegister: "원외탕전업체에서 제공하는 엑셀파일을 원내한약재로 일괄등록합니다.",
  },
  reservation: {
    cancelConfirm: "예약 취소 확인",
    timeUnitHelp: "예약 시간 단위를 10분, 15분, 20분, 30분, 60분 으로 설정할 수 있습니다.\n관리자가 설정가능합니다.",
    timeUnitEdit: "예약시간 단위 변경하기",
    memoHelp: "예약메모의 첫 글자가 예약 타임테이블에 표시됩니다.\n추나로 입력시\n홍길동[추] 로 표시됩니다.",
    doctalkActionBlocked: "닥톡 예약은 차트에서 변경/취소/삭제할 수 없습니다. 해당 플랫폼에서 처리해주세요.",
    waitingNeedsConfirmation: "예약확정이 필요합니다",
  },
  layout: {
    resetWindowLayout: "크기·위치 초기화",
  },
  side: {
    certificateDownload: "클릭하면 인증서를 다운로드할 수 있습니다.",
  },
  closing: {
    statisticsGuide: "일간, 주간, 월간 통계는 관리-통계 메뉴를 확인하세요.",
  },
} as const

type TooltipNamespaces = typeof tooltipMessagesByNamespace
type TooltipNamespace = keyof TooltipNamespaces

declare const tooltipTitleTokenSymbol: unique symbol
export type TooltipTitleToken = string & { readonly [tooltipTitleTokenSymbol]: true }

const toTooltipTitleToken = (value: string): TooltipTitleToken => value as TooltipTitleToken

export type TooltipRegistryKey = {
  [NS in TooltipNamespace]: `${NS}.${Extract<keyof TooltipNamespaces[NS], string>}`
}[TooltipNamespace]

const tooltipTextByKey: Record<string, string> = Object.entries(tooltipMessagesByNamespace).reduce(
  (accumulator, [namespace, messages]) => {
    Object.entries(messages).forEach(([messageKey, text]) => {
      accumulator[`${namespace}.${messageKey}`] = text
    })
    return accumulator
  },
  {} as Record<string, string>
)

const tooltipAliasToKey: Record<string, TooltipRegistryKey> = {
  확대: "common.zoomIn",
  축소: "common.zoomOut",
  최소화: "common.minimize",
  최대화: "common.maximize",
  권한없음: "common.noPermission",
  "창 닫기": "common.closeWindow",
  삭제: "common.delete",
  제출: "common.submit",
  인쇄: "common.print",
  제외: "common.exclude",
  "해당 차트 열기": "dashboard.openChart",
  "보험종류 변경": "dashboard.insuranceTypeChange",
  "보험정보 보기": "dashboard.insuranceInfoView",
  "자보 보험 추가": "dashboard.insuranceAddTa",
  "산재 보험 추가": "dashboard.insuranceAddAi",
  보험시작일: "dashboard.insuranceStartDate",
  보장기관기호: "dashboard.insuranceOrgCode",
  보험증번호: "dashboard.insuranceCardNumber",
  "환자정보 수정방법 안내": "dashboard.editPatientInfoGuide",
  자격조회: "dashboard.qualificationCheck",
  "가족 조회": "dashboard.openFamilyLookup",
  주소복사: "dashboard.copyAddress",
  "진료 이력 보기": "dashboard.openHistory",
  "지난 요약보기": "dashboard.openMonthlySummary",
  "바이털 입력": "dashboard.openVital",
  바이탈: "dashboard.openVital",
  처방복사하기: "dashboard.copyPrescription",
  "해당 진료 수정": "dashboard.editEncounter",
  "새 메모 작성": "dashboard.newMemo",
  "진료의 변경": "dashboard.changeDoctor",
  "접수메모 변경": "dashboard.changeReceptionMemo",
  "진료과목 수정": "dashboard.changeDepartment",
  수납하기: "dashboard.receipt",
  "처방미완료\n수납하기": "dashboard.receiptPrescriptionIncomplete",
  접수하기: "dashboard.registerPatient",
  "이전 단계": "dashboard.stepPrev",
  "다음 단계": "dashboard.stepNext",
  "치료 종료": "dashboard.treatmentComplete",
  "환자 삭제": "dashboard.deletePatient",
  "진료 수정": "encounter.editEncounter",
  "최근 상병 불러오기": "encounter.kcdHistoryLoad",
  "상병코드 검색": "encounter.kcdSearch",
  "산정특례기호 입력 및 검색": "encounter.disRegCodeInputSearch",
  상병코드관리: "encounter.kcdManage",
  "상병 추가": "encounter.kcdAdd",
  "처방입력 버튼을 삭제하거나 추가할 수 있습니다.해당편집은 바로 적용되며 병원전체에 적용됩니다.": "encounter.prescriptionGuide",
  "치료부위가 기록되지 않은 처방에 상병에 따른 추천치료부위를 입력합니다.": "encounter.treatmentAreaRecommend",
  "진료기록부 하단에 추가로 처방과 그에 따른 치료부위를 입력합니다.": "encounter.treatmentRecordAppend",
  "목록 새로고침": "encounter.refreshList",
  새로고침: "encounter.refresh",
  "원외탕전 수정": "encounter.editExternalPharma",
  "추나 심평원 조회": "encounter.chunaHiraLookup",
  더보기: "top.more",
  메뉴검색하기: "top.menuSearch",
  "오늘 날짜로 리셋": "top.resetToToday",
  "이전 날짜": "top.prevDate",
  "다음 날짜": "top.nextDate",
  "시그마차트 신청하기": "top.sigmaChartApplication",
  신환등록: "top.menuNewPatient",
  환자관리: "top.menuPatientManagement",
  자보환자: "top.menuTaPatient",
  "비급여/한약": "top.menuUninsuredHerbal",
  메시지: "top.menuSmsSend",
  예약: "top.menuReservation",
  결산: "top.menuSettlement",
  청구: "top.menuClaim",
  관리: "top.menuControl",
  로그아웃: "top.logout",
  "문자 발송내역 보기": "sms.sendHistoryView",
  "심평원 동기화": "hira.syncHira",
  "이 날짜의 통계 재계산": "control.recalcDaily",
  "이 주간 통계 재계산": "control.recalcWeekly",
  "이 월간 통계 재계산": "control.recalcMonthly",
  "이 연간 통계 재계산": "control.recalcYearly",
  "예약 취소 확인": "reservation.cancelConfirm",
  "예약 시간 단위를 10분, 15분, 20분, 30분, 60분 으로 설정할 수 있습니다.": "reservation.timeUnitHelp",
  "예약시간 단위 변경하기": "reservation.timeUnitEdit",
  "예약메모 도움말": "reservation.memoHelp",
  "크기·위치 초기화": "layout.resetWindowLayout",
  "화면 캡쳐": "chat.captureScreen",
  "파일 선택": "chat.selectFile",
  다운로드: "chat.download",
  "폴더 열기": "chat.openFolder",
}

const resolveTooltipKeyToText = (key: string): string | null => {
  return tooltipTextByKey[key] ?? null
}

const resolveAliasToText = (title: string): string | null => {
  const key = tooltipAliasToKey[title]
  if (!key) {
    return null
  }
  return tooltipTextByKey[key] ?? null
}

export const tooltipTitleByKey = (key: TooltipRegistryKey): TooltipTitleToken => {
  return toTooltipTitleToken(`tooltip:${key}`)
}

export const tooltipTemplateByKey = {
  dashboard: {
    chartNo: (chartNo?: string | number | null): TooltipTitleToken => toTooltipTitleToken(`차트번호: ${chartNo ?? "-"}`),
    chartNoWithPatientName: (chartNo?: string | number | null, name?: string | null): TooltipTitleToken =>
      toTooltipTitleToken(`차트번호: ${chartNo ?? "-"}${name ? `\n${name}` : ""}`),
    patientName: (name?: string | null, fallbackName?: string | null): TooltipTitleToken => toTooltipTitleToken(name || fallbackName || ""),
    patientFullAddress: (address?: string | null, detailAddress?: string | null): TooltipTitleToken =>
      toTooltipTitleToken([address?.trim(), detailAddress?.trim()].filter(Boolean).join(", ")),
    panelExpand: (expanded: boolean): TooltipTitleToken => toTooltipTitleToken(expanded ? "패널 축소" : "패널 확대"),
    waitingRoomToggle: (open: boolean): TooltipTitleToken => toTooltipTitleToken(open ? "대기실화면 숨기기" : "대기실화면"),
    treatmentRoomToggle: (showTreatmentRoom: boolean): TooltipTitleToken => toTooltipTitleToken(showTreatmentRoom ? "치료실 숨기기" : "치료실 보기"),
    insuranceCreate: (insuranceType?: string | null): TooltipTitleToken => toTooltipTitleToken(`신규 ${insuranceType || ""} 등록`),
    symptomMemo: (memo?: string | null): TooltipTitleToken => toTooltipTitleToken(memo || "증상기록 없음"),
    pinToggle: (isPinned: boolean): TooltipTitleToken => toTooltipTitleToken(isPinned ? "핀 해제" : "핀 고정"),
    panelPinToggle: (isPinned: boolean): TooltipTitleToken => toTooltipTitleToken(isPinned ? "고정 해제" : "고정"),
    kioskImageTitle: (imageTitle?: string | null): TooltipTitleToken => toTooltipTitleToken(imageTitle || "키오스크 업로드 이미지"),
    label: (value?: string | null): TooltipTitleToken => toTooltipTitleToken(value || ""),
  },
  encounter: {
    generic: (text?: string | null): TooltipTitleToken => toTooltipTitleToken(text || ""),
    taInsuranceReceiptNumber: (receiptNumber?: string | null): TooltipTitleToken => toTooltipTitleToken(`접수번호: ${receiptNumber?.trim() || "-"}`),
    medicalRecordPinToggle: (isPinned: boolean): TooltipTitleToken => toTooltipTitleToken(isPinned ? "진료기록 핀 해제" : "진료기록 핀 고정"),
    doctorMismatchChart: (doctorName?: string | null): TooltipTitleToken =>
      toTooltipTitleToken(`타 진료의가 생성한 차트입니다. 수정은 클릭해서 진료의변경후 가능합니다.`),
  },
  payment: {
    taxableDisabled: (isDisabled: boolean): TooltipTitleToken => toTooltipTitleToken(isDisabled ? "과세 항목이 없거나 금액이 0원입니다." : ""),
  },
  common: {
    fallback: (primary?: string | null, fallback?: string | null): TooltipTitleToken => toTooltipTitleToken(primary || fallback || ""),
    nodeFallback: (primary: ReactNode | null | undefined, fallback: ReactNode): ReactNode => primary ?? fallback,
  },
} as const

export const resolveTooltipTitle = (title: ReactNode): ReactNode => {
  if (typeof title !== "string") {
    return title
  }

  // 키 기반 호출: title={tooltipTitleByKey("dashboard.receipt")}
  if (title.startsWith("tooltip:")) {
    const key = title.replace("tooltip:", "")
    return resolveTooltipKeyToText(key) ?? title
  }

  // 기존 문자열 title는 alias를 통해 레지스트리로 매핑 (하위 호환)
  const aliasText = resolveAliasToText(title)
  if (aliasText !== null) {
    return aliasText
  }

  return title
}
